import { Checkbox } from 'antd';
import styled from 'styled-components';

export const StyledNotification = styled.div`
  color: ${({ theme }) => theme.headerColor};
`;

export const StyledCheckbox = styled(Checkbox)`
  height: 1rem;
`;
